import { GetApp } from "@material-ui/icons";
import { observer } from "mobx-react";
import { Button, Grid } from "@material-ui/core";
import { ManufacturePackagingListRowData } from "../../../../../data/store/pageStore/manufacture/ManufacturePackagingListStore";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import ManufactureItem from "../../../../../data/model/manufacture/ManufactureItem";

interface Props {
    data?: ManufacturePackagingListRowData[];
    isLoaded?: boolean;
}

const toCSVData = (data: ManufacturePackagingListRowData[]) => {
    let index = 0;
    const d = data.filter(f => f.isSelected).flatMap(v =>
        v.works?.flatMap(u => (
            u.itemList.map(i => ({
                '#': ++index,
                'Project Code (ERP)': u?.erpCode,
                'Box No.': v.boxNO,
                'Items': u.withOEMItemName(i.packagingListItemName, i.itemOptions.version),
                'Cat No.': i.manipulatedCatNO ? (u?.withOEMPrefixCatNo ? u.withOEMPrefixCatNo(i.manipulatedCatNO, i.itemOptions.version) : i.manipulatedCatNO) : '',
                'Lot No.': i.lotNO ? (u?.concatCatNoAndLotNo ? u.concatCatNoAndLotNo(i.manipulatedCatNO, i.lotNO, i.itemOptions.version) : i.lotNO) : i.lotNO,
                'Q\'ty': i.qty,
                'StorageTemp': (ManufactureItem.StorageTempList as any)[i.storageTemp],
                'Remark': i?.remark,
                'ProbeID': i.probeID,
                'Options': i.itemOptions.getPackgingOptionsString(),
                'ShippingCondition': (ManufactureItem.ShippingCoditionList as any)[i.shippingCondition],
                'Exp. Date': i.expDate ? dayjs(i.expDate).format('YYYY-MM-DD') : '',
            }))
        )) || []
    );
    return d;
};

const ManufacturePackagingListPrintComponent: React.FC<Props> = observer((props) => {
    const data = props.data ?? [];
    const isLoaded = props.isLoaded ?? false;
    return (
        <>
            <Grid container style={{ marginBottom: 15 }}>
                <Grid item xl lg md sm>
                    <CSVLink
                        data={toCSVData(data)}
                        filename={`PackingList_merged_${dayjs().format('YYYYMMDD')}`}
                        onClick={() => { if (!data) return; }}
                        style={{
                            textDecoration: 'none'
                        }}
                    >
                        <Button
                            disabled={!isLoaded}
                            color='primary'
                            variant='contained'
                            style={{ marginRight: 10 }}>
                            선택 패킹 리스트 다운로드
                            <GetApp />
                        </Button>
                    </CSVLink>
                </Grid>
            </Grid>
        </>
    )
})

export default ManufacturePackagingListPrintComponent;
